<template>
    <div class="lesson-data-page">
        <div class="lesson-data-body">
            <div class="container">
                <h3>{{lessonInfo.lessonName}}</h3>
                <el-row :gutter="6">
                    <el-col :span="14">
                        <el-card shadow="never">
                            <div class="statistical-switch">
                                <p>
                                    <span v-for="(item,key) in screen" :key="key" @click="handCurSearchKey(key)" :class="{'active' : key === curSearchKey}">{{item}}</span>
                                </p>
                            </div>
                            <div v-show="curSearchKey==='exp'">
                                <div class="subsection-chart-box" ref="subsectionChartExp">subsectionChartExp</div>
                            </div>
                            <div v-show="curSearchKey==='task'">
                                <div class="subsection-chart-box" ref="subsectionChartTask">subsectionChartTask</div>
                            </div>
                            <el-row class="statistical-switch-bottom">
                                <el-col :span="12">
                                    <span>所占学生人数&nbsp;&nbsp;<i>{{activeSInfo.count}}</i>&nbsp;&nbsp;人</span>
                                </el-col>
                                <el-col :span="12">
                                    <span>所占比率&nbsp;&nbsp;<i>{{activeSInfo.proportion}}</i>&nbsp;&nbsp;%</span>
                                </el-col>
                            </el-row>
                        </el-card>
                    </el-col>
                    <el-col :span="10">
                        <el-row>
                            <el-col :span="24">
                                <el-card shadow="never" class="data-analysis-top">
                                    <h1>{{studentCount}}</h1>
                                    <p>
                                        <img src="~@/assets/imgs/analysis/student.png" style="vertical-align:bottom">课堂成员数
                                    </p>
                                </el-card>
                            </el-col>
                            <el-col :span="24">
                                <el-card shadow="never" :body-style="{ padding: '0px' }" v-show="curSearchKey==='exp'">
                                    <el-row class="data-analysis-bottom">
                                        <el-col :span="12">
                                            <h2>{{LExpCount}}</h2>
                                            <p>实验总发布数</p>
                                        </el-col>
                                        <el-col :span="12">
                                            <div class="exp-submit-echarts" ref="expSubmitEcharts"></div>
                                            <p>实验提交情况</p>
                                        </el-col>
                                        <el-col :span="12">
                                            <div class="exp-pass-echarts" ref="expPassEcharts"></div>
                                            <p>实验合格情况</p>
                                        </el-col>
                                        <el-col :span="12">
                                            <h2>
                                                <img src="~@/assets/imgs/analysis/exp-time.png">
                                                <p>{{formatterTime(LExpDuration)}}</p>
                                            </h2>
                                            <p>实验总时长</p>
                                        </el-col>
                                    </el-row>
                                </el-card>
                                <el-card shadow="never" :body-style="{ padding: '0px' }" v-show="curSearchKey==='task'">
                                    <el-row class="data-analysis-bottom">
                                        <el-col :span="12">
                                            <h2>{{taskCount}}</h2>
                                            <p>
                                                <img src="~@/assets/imgs/analysis/release.png" style="vertical-align:bottom">作业总发布数
                                            </p>
                                        </el-col>
                                        <el-col :span="12">
                                            <h2 style="color:#14d2c8" :title="`${taskPuSC} 人次`">
                                                {{taskSC > 0 ? parseInt(taskPuSC / taskSC * 100) : 0}}%
                                            </h2>
                                            <p>
                                                <img src="~@/assets/imgs/analysis/task-submit.png" style="vertical-align:bottom">
                                                作业准时提交率
                                            </p>
                                        </el-col>
                                        <el-col :span="12">
                                            <h2 style="color:#3ca0f0" :title="`${taskSC} 人次`">
                                                {{
                                                    taskCount * studentCount > 0
                                                        ? parseInt(taskSC / (taskCount * studentCount) * 100)
                                                        : 0
                                                }}%
                                            </h2>
                                            <p>
                                                <img src="~@/assets/imgs/analysis/task-all-pass.png" style="vertical-align:bottom">
                                                作业总提交率
                                            </p>
                                        </el-col>
                                        <el-col :span="12">
                                            <h2 style="color:#be6ef0" :title="`${taskPassC ? taskPassC : 0} 人次`">
                                                {{
                                                    taskPassC && taskSC > 0
                                                        ? parseInt(taskPassC / taskSC * 100)
                                                        : 0
                                                }}%
                                            </h2>
                                            <p>
                                                <img src="~@/assets/imgs/analysis/task-pass.png" style="vertical-align:bottom">
                                                作业合格率
                                            </p>
                                        </el-col>
                                    </el-row>
                                </el-card>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
                <el-row style="margin-top:6px;">
                    <el-col :span="24">
                        <el-card shadow="never" :body-style="{padding:'24px 12px'}">
                            <el-row class="exp-score-static">
                                <el-col :span="4">
                                    <el-button type="success" size="small" @click="exportExp">导出课堂实验成绩</el-button>
                                </el-col>
                                <el-col :span="16">
                                    <span>个人成绩统计</span>
                                </el-col>
                                <el-col :span="4">
                                    <el-button type="success" size="small" @click="exportTask">导出课堂作业成绩</el-button>
                                </el-col>
                            </el-row>
                            <el-table :data="studentSt" @row-click="handleRowClick">
                                <el-table-column label="排名" align="center">
                                    <template slot-scope="{ row, column, $index }">
                                        <img src="~@/assets/imgs/analysis/gold.png" v-if="$index + 1 + (page.page - 1) * page.limit === 1">
                                        <img src="~@/assets/imgs/analysis/silver.png" v-else-if="$index + 1 + (page.page - 1) * page.limit === 2">
                                        <img src="~@/assets/imgs/analysis/copper.png" v-else-if="$index + 1 + (page.page - 1) * page.limit === 3">
                                        <span v-else>{{$index + 1 + (page.page - 1) * page.limit}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="姓名" prop="nickname" align="center"></el-table-column>
                                <el-table-column label="成绩" align="center">
                                    <el-table-column label="总成绩" prop="totalScore" align="center"></el-table-column>
                                    <el-table-column label="实验成绩" prop="lessonExpScore" align="center"></el-table-column>
                                    <el-table-column label="作业成绩" prop="taskScore" align="center"></el-table-column>
                                </el-table-column>
                                <el-table-column label="参与率(%)" align="center" :formatter="ParRateFormatter">
                                </el-table-column>
                                <el-table-column label="合格率(%)" prop="three" align="center" :formatter="PassRateFormatter"></el-table-column>
                                <el-table-column type="expand">
                                    <template slot-scope="{row}">
                                        <el-form label-position="left" inline class="expand-left" label-width="120px">
                                            <el-form-item label="已提交实验数 :">
                                                <span>{{row.submitLessonExpCount}}</span>
                                            </el-form-item>
                                            <el-form-item label="合格实验数 :">
                                                <span>{{row.lessonExpPassCount}}</span>
                                            </el-form-item>
                                        </el-form>
                                        <el-form label-position="left" inline class="expand-right" label-width="120px">
                                            <el-form-item label="已提交作业数 :">
                                                <span>{{row.submitTaskCount}}</span>
                                            </el-form-item>
                                            <el-form-item label="合格作业数 :">
                                                <span>{{row.passTaskCount}}</span>
                                            </el-form-item>
                                        </el-form>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <el-pagination style="margin-top:15px" background prev-text="上一页" next-text="下一页" layout="total, prev, pager, next, jumper" :total="studentCount" :current-page="page.page" :page-size="page.limit" @current-change="handlePageChange" hide-on-single-page></el-pagination>
                        </el-card>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { formatterTime } from '@/utils/formatter'
import { getLessonUserStatistics } from '@/api/lab/lesson2user'
import { getLessonStatistics } from '@/api/lab/statistics'
import { getDetail } from '@/api/lab/lesson'
import { exportExcel } from '@/api/common'

const scoreGrade = [
    { value: 0, name: '优秀' },
    { value: 0, name: '良好' },
    { value: 0, name: '中等' },
    { value: 0, name: '及格' },
    { value: 0, name: '差' }
]
export default {
    data () {
        return {
            studentCount: 0, // 课堂学生数
            LExpCount: 0, // 课堂实验数
            LExpDuration: 0, // 实验总时长
            LESubProbability: 0, // 课堂实验提交率
            taskCount: 0, // 作业总发布数
            taskSC: 0, // 作业提交数
            taskPuSC: 0, // 作业准时提交数
            taskPassC: 0, // 作业合格数
            curSearchKey: '',
            screen: {
                exp: '实验总体统计',
                task: '作业总体统计'
            },
            searchText: '',
            LEData: scoreGrade, // 实验等级
            TData: scoreGrade, // 作业等级
            studentSt: [], // 课堂各学生的参与情况
            page: {
                page: 1,
                limit: 8
            },
            activeSInfo: {
                count: 0,
                proportion: 0
            },
            taskArr: [],
            expArr: [],
            expTime: '',
            taskTime: '',
            arr: [],
            newArr: [],
            lessonInfo: {},
            expEcahTime: null
        }
    },
    computed: {
        ...mapGetters(['userInfo']),
    },
    watch: {
        LEData: {
            handler () {
                if (this.curSearchKey === 'exp')
                    this.initExpSummaryChart()
            },
            deep: true,
            immediate: true
        },
        TData: {
            handler () {
                if (this.curSearchKey === 'task')
                    this.initTaskSummaryChart()
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        exportExp(){  //导出实验成绩
            const { uid } = this.$route.params
            // exportExcel('lab/labexperiment2user',{ lessonUid:uid })
            exportExcel('lab/labexperiment2user',{ lessonUid: uid })
        },
        exportTask(){  //导出实验成绩
            const { uid } = this.$route.params
            exportExcel('lab/labtask2user',{ lessonUid: uid })
        },
        handleRowClick ({ userId, lessonUid }) {
            this.$router.push(`/lesson/${lessonUid}/coursedata/${userId}`)
        },
        // 参与率格式化
        ParRateFormatter ({
            submitLessonExpCount = 0,
            submitTaskCount = 0
        }) {
            const {
                taskCount = 0,
                LExpCount = 0
            } = this
            if (taskCount > 0 || LExpCount > 0)
                return parseInt((submitLessonExpCount + submitTaskCount) / (taskCount + LExpCount) * 100)
            return '-'
        },
        // 合格率格式化
        PassRateFormatter ({
            lessonExpPassCount,
            passTaskCount,
            submitTaskCount,
            submitLessonExpCount
        }) {
            if (submitTaskCount > 0 || submitLessonExpCount > 0)
                return parseInt((lessonExpPassCount + passTaskCount) / (submitTaskCount + submitLessonExpCount) * 100)
            return '-'
        },
        formatterTime (second) {
            return formatterTime(second)
        },
        // page 改变时会触发
        handlePageChange (page) {
            this.$set(this.page, 'page', page)
            this.getStudentSt()
        },
        async getStudentSt () {
            const { uid } = this.$route.params
            let list = []
            await getLessonUserStatistics({
                lessonUid: uid,
                page: this.page.page,
                limit: this.page.limit
            }).then(res => {
                list = res
            }).catch(() => { })
            this.studentSt = list
        },
        handCurSearchKey (key) {
            let value = key
            if (!value || !this.screen[value]) {
                value = Object.keys(this.screen)[0]
            }
            this.curSearchKey = value
            switch (value) {
                case 'exp':
                    this.initExpSummaryChart()
                    break;
                case 'task':
                    this.initTaskSummaryChart()
                    break;
                default:
                    break;
            }
        },
        timeTotal (t) { // 计算总实验时长
            const m = Math.floor(t % 3600);
            if (t) {
                return Math.floor(t / 3600) + "时" + Math.floor(m / 60) + "分" + t % 60 + "秒"
            } else {
                return 0
            }
        },
        init () {
            this.getStudentSt()
            this.initCharts()
            this.handCurSearchKey()
            this.getTotalScore()
        },
        async getInfo () {
            let { uid } = this.$route.params
            let info = {}
            // 获取课堂详情
            await getDetail(uid).then(res => {
                info = res
            }).catch(() => { })
            this.lessonInfo = info
        },
        // 获取课堂总成绩统计数据
        async getTotalScore () {
            const { uid } = this.$route.params
            let subExpCount = 0
            let expCount = 1
            let expEndCount = 0
            let qualifiedExpCount = 0
            await getLessonStatistics(uid).then(res => {
                const {
                    studentCount,
                    lessonExpCount,
                    lessonExpSubCount,
                    lessonExpEndCount,
                    lessonExpPassCount,
                    lessonExpDuration,
                    lessonExpSummary,
                    taskCount,
                    taskSubCount,
                    taskPassCount,
                    taskPunctualSubCount,
                    taskSummary
                } = res

                let LEData = []
                let TData = []

                expEndCount = lessonExpEndCount
                subExpCount = lessonExpSubCount + lessonExpEndCount
                qualifiedExpCount = lessonExpPassCount
                expCount = lessonExpCount * studentCount

                this.LEData.map(LEItem => {
                    let oItem = JSON.parse(JSON.stringify(LEItem))
                    lessonExpSummary.map(item => {
                        if (oItem.name === item.grade) {
                            oItem.value = item.count
                        }
                    })
                    LEData.push(oItem)
                })

                this.TData.map(TItem => {
                    let oItem = JSON.parse(JSON.stringify(TItem))
                    taskSummary.map(item => {
                        if (oItem.name === item.grade) {
                            oItem.value = item.count
                        }
                    })
                    TData.push(oItem)
                })

                this.studentCount = studentCount
                this.LExpCount = lessonExpCount
                this.LExpDuration = lessonExpDuration
                this.taskCount = taskCount
                this.taskSC = taskSubCount
                this.taskPuSC = taskPunctualSubCount
                this.taskPassC = taskPassCount
                this.LEData = LEData
                this.TData = TData
            }).catch(() => { })
            this.expSubmitEcharts(subExpCount, expCount)
            this.expPassEcharts(qualifiedExpCount, expEndCount)
        },
        initCharts () {
            this.getInfo()
        },
        /**
         * 实验总提交率图表
         * join 提交的实验数
         * totalCount 总实验数
         */
        expSubmitEcharts (join = 0, totalCount = 1) {
            this.$nextTick(() => {
                let dom = this.$refs.expSubmitEcharts
                let myChart = this.$echarts.init(dom)
                if (totalCount < 1)
                    totalCount = 1
                myChart.setOption({
                    // 图例组件
                    legend: {
                        show: false
                    },
                    graphic: [
                        { //环形图中间添加文字
                            type: 'text', //通过不同top值可以设置上下显示
                            left: 'center',
                            top: '55%',
                            style: {
                                text: join,
                                textAlign: 'center',
                                fill: '#00b41e', // 文字的颜色
                                width: 30,
                                height: 30,
                                fontSize: 14,
                                fontFamily: "Microsoft YaHei",
                            }
                        },
                        {
                            type: 'text',
                            left: '56%',
                            top: '55%',
                            style: {
                                text: '人次',
                                fill: '#333',
                                width: 30,
                                height: 28,
                                fontSize: 9,
                                fontFamily: "Microsoft YaHei"
                            }
                        }
                    ],
                    series: [
                        {
                            type: 'pie',
                            radius: ['70%', '100%'], // 饼图的半径
                            center: ['50%', '70%'], // 饼图的中心（圆心）坐标，数组的第一项是横坐标，第二项是纵坐标
                            startAngle: 180, // 起始角度，支持范围[0, 360]
                            // 饼图图形上的文本标签，可用于说明图形的一些数据信息，比如值，名称等
                            label: {
                                show: false,
                                formatter: ({ percent }) => {
                                    return `${percent * 2}%`
                                },
                                position: 'inside'
                            },
                            silent: true, // 图形是否不响应和触发鼠标事件，默认为 false，即响应和触发鼠标事件
                            data: [
                                {
                                    value: join,
                                    name: '已交',
                                    itemStyle: {
                                        color: '#1efaaa'
                                    },
                                    label: {
                                        show: true
                                    }
                                },
                                {
                                    value: totalCount - join,
                                    name: '未交',
                                    itemStyle: {
                                        color: '#e6e6e6'
                                    }
                                },
                                {
                                    value: totalCount,
                                    name: '__other',
                                    itemStyle: {
                                        color: 'rgba(0,0,0,0)'
                                    }
                                }
                            ]
                        }
                    ]
                })
            })
        },
        /**
         * 实验合格率图表
         * join 合格数
         * totalCount 总数
         */
        expPassEcharts (join = 0, totalCount = 1) {
            this.$nextTick(() => {
                let dom = this.$refs.expPassEcharts
                let myChart = this.$echarts.init(dom)
                if (totalCount < 1)
                    totalCount = 1
                myChart.setOption({
                    legend: {
                        show: false,
                        orient: 'vertical',
                        x: 'left',
                        data: ['合格', '未合格', '__other']
                    },
                    graphic: [
                        { //环形图中间添加文字
                            type: 'text', //通过不同top值可以设置上下显示
                            left: 'center',
                            top: '55%',
                            style: {
                                text: join,
                                textAlign: 'center',
                                fill: '#1eb4ff', //文字的颜色
                                width: 30,
                                height: 30,
                                fontSize: 14,
                                fontFamily: "Microsoft YaHei",
                            }
                        },
                        {
                            type: 'text',
                            left: '56%',
                            top: '55%',
                            style: {
                                text: '人次',
                                fill: '#333',
                                width: 30,
                                height: 28,
                                fontSize: 9,
                                fontFamily: "Microsoft YaHei"
                            }
                        }
                    ],
                    series: [
                        {
                            name: '分段统计',
                            type: 'pie',
                            radius: ['70%', '100%'],
                            center: ['50%', '70%'],//距离左右，上下距离的百分比
                            startAngle: 180,
                            avoidLabelOverlap: false,
                            hoverAnimation: false,
                            labelLine: {
                                normal: {
                                    show: false
                                }
                            },
                            silent: true,
                            label: {
                                show: false,
                                formatter: ({ percent }) => {
                                    return `${percent * 2}%`
                                },
                                position: 'inside'
                            },
                            data: [
                                {
                                    value: join,
                                    name: '合格',
                                    itemStyle: {
                                        color: '#1eb4ff'
                                    },
                                    label: {
                                        show: true
                                    }
                                },
                                {
                                    value: totalCount - join,
                                    name: '未合格',
                                    itemStyle: {
                                        color: '#e6e6e6'
                                    }
                                },
                                {
                                    value: totalCount,
                                    name: '__other',
                                    itemStyle: {
                                        color: 'rgba(0,0,0,0)'
                                    }
                                }
                            ]
                        }
                    ]
                })
            })
        },
        // 课堂作业的成绩分段统计信息
        initTaskSummaryChart () {
            const { TData } = this
            this.$nextTick(() => {
                let dom = this.$refs.subsectionChartTask
                let myChart = this.$echarts.getInstanceByDom(dom)
                if (myChart) {
                    // 刷新数据
                    var option = myChart.getOption()
                    option.series[0].data = TData
                    myChart.setOption(option)
                } else {
                    myChart = this.$echarts.init(dom)
                    myChart.setOption({
                        legend: {
                            x: 'left',
                            type: 'scroll',
                            itemWidth: 12,
                            itemHeight: 12,
                        },
                        series: [
                            {
                                name: '分段统计',
                                type: 'pie',
                                radius: '66%',
                                center: ['50%', '55%'],//距离左右，上下距离的百分比
                                avoidLabelOverlap: false,
                                label: {
                                    normal: {
                                        show: false,
                                        position: 'inside',
                                    },
                                    emphasis: {
                                        show: true,
                                        align: 'center',
                                        formatter: '{b}\n{d}%',
                                        lineHeight: 24,
                                        textStyle: {
                                            fontSize: '18',
                                        }
                                    }
                                },
                                itemStyle: {
                                    normal: {
                                        color: function (params) {
                                            //自定义颜色
                                            var colorList = ['#239bff', '#f56496', '#ffb419', '#b4eb32', '#5a64f0'];
                                            return colorList[params.dataIndex]
                                        }
                                    }
                                },
                                data: TData
                            }
                        ]
                    })
                    myChart.on('mouseover', params => {
                        const { percent, value } = params
                        this.activeSInfo = {
                            count: value,
                            proportion: percent
                        }
                    })
                    myChart.on('mouseout', () => {
                        this.activeSInfo = {
                            count: 0,
                            proportion: 0
                        }
                    })
                }
            })
        },
        // 课堂实验的成绩分段统计信息
        initExpSummaryChart () {
            const { LEData } = this
            this.$nextTick(() => {
                let dom = this.$refs.subsectionChartExp
                let myChart = this.$echarts.getInstanceByDom(dom)
                if (myChart) {
                    // 刷新数据
                    var option = myChart.getOption()
                    option.series[0].data = LEData
                    myChart.setOption(option)
                } else {
                    myChart = this.$echarts.init(dom)
                    myChart.setOption({
                        tooltip: {
                            trigger: 'item',
                            formatter: "{d}%"
                        },
                        legend: {
                            x: 'left',
                            type: 'scroll',
                            itemWidth: 12,
                            itemHeight: 12,
                        },
                        series: [
                            {
                                name: '分段统计',
                                type: 'pie',
                                radius: ['32%', '66%'],
                                center: ['50%', '55%'],//距离左右，上下距离的百分比
                                avoidLabelOverlap: false,
                                label: {
                                    normal: {
                                        show: false,
                                        position: 'center',
                                    },
                                    emphasis: {
                                        show: true,
                                        align: 'center',
                                        formatter: ['{b|{b}}', '{c|{c}人}'].join('\n'),
                                        lineHeight: '30',
                                        textStyle: {
                                            fontSize: '24'
                                        },
                                        rich: {
                                            c: {
                                                color: '#333',
                                                fontSize: '18',
                                            }
                                        }
                                    }
                                },
                                itemStyle: {
                                    normal: {
                                        color: function (params) {
                                            //自定义颜色
                                            var colorList = ['#239bff', '#f56496', '#ffb419', '#b4eb32', '#5a64f0'];
                                            return colorList[params.dataIndex]
                                        }
                                    }
                                },
                                data: LEData
                            }
                        ]
                    })
                    myChart.on('mouseover', params => {
                        const { percent, value } = params
                        this.activeSInfo = {
                            count: value,
                            proportion: percent
                        }
                    })
                    myChart.on('mouseout', () => {
                        this.activeSInfo = {
                            count: 0,
                            proportion: 0
                        }
                    })
                }
            })
        },
    },
    mounted () {
        this.$nextTick(() => {
            this.init()
        })
    }
}
</script>

<style lang="scss">
.lesson-data-page {
    > .el-card {
        .el-card__body {
            padding: 10px;
            font-size: 14px;
            i {
                font-size: 20px;
                color: #14b14e;
            }
        }
    }
    .card {
        > div {
            margin-bottom: 6px;
        }
        .card-box {
            height: 94.5px;
            .titledataname {
                font-size: 0.8em;
            }
            .titledatanum {
                height: 60px;
                line-height: 60px;
                font-size: 2em;
                color: #44A8F3;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
    .flag {
        text-align: center;
        color: #444;
        font-weight: 600;
    }
    .tip {
        text-align: center;
        p:nth-of-type(1) {
            font-size: 1em;
        }
        p:nth-of-type(2) {
            height: 60px;
            line-height: 60px;
            font-size: 2em;
        }
    }
    .lesson-data-body {
        margin-top: 25px;
        padding-bottom: 200px;
        .el-card__body {
            padding: 24px 12px;
        }
        h3 {
            height: 36px;
            font: 500 24px "微软雅黑";
            color: #1d1d1d;
            line-height: 36px;
            margin: 24px 0 12px 0;
        }
        .statistical-switch {
            height: 60px;
            p {
                font: 400 18px "微软雅黑";
                border-bottom: 1px solid #dcdcdc;
                text-align: center;
                padding-bottom: 12px;
                span {
                    padding: 0 12px;
                    color: #999;
                    cursor: pointer;
                }
                span:nth-of-type(1) {
                    border-right: 1px solid #969696;
                }
                .active {
                    color: #333;
                }
            }
        }
        .statistical-switch-bottom {
            text-align: center;
            font-size: 14px;
            color: #333;
            > div:nth-of-type(1) {
                border-right: 1px solid #e6e6e6;
            }
            span {
                display: inline-block;
                line-height: 72px;
                height: 72px;
                padding: 0 48px;
                i {
                    width: 60px;
                    display: inline-block;
                    font-style: normal;
                    font: 500 24px "微软雅黑";
                }
            }
        }
        .subsection-chart-box {
            height: 400px;
        }
        .data-analysis-top {
            text-align: center;
            margin-bottom: 6px;
            h1 {
                font: 500 48px "微软雅黑";
                line-height: 36px;
                margin: 32px 0;
                color: #dc1e5a;
            }
            p {
                line-height: 24px;
                font-size: 14px;
            }
        }
        .data-analysis-bottom {
            > div {
                height: 200px;
                text-align: center;
                font-size: 14px;
                .exp-submit-echarts,
                .exp-pass-echarts,
                h2 {
                    font-size: 36px;
                    color: #ff3c3f;
                    height: 150px;
                    line-height: 150px;
                    position: relative;
                    img {
                        margin-top: 24px;
                        width: 75%;
                    }
                    p {
                        font-size: 14px;
                        position: absolute;
                        width: 100%;
                        top: 110px;
                        left: 0px;
                    }
                }
                p {
                    line-height: 24px;
                }
            }
        }
        .exp-score-static {
            height: 48px;
            line-height: 48px;
            font: 600 18px "微软雅黑";
            text-align: center;
            position: relative;
        }
        .expand-left,
        .expand-right {
            display: inline-block;
            width: 50%;
            padding: 0 100px;
            .el-form-item {
                width: 100%;
                .el-form-item__label {
                    color: #99a9bf;
                    font-weight: 500;
                }
            }
        }
    }
}
</style>
